module.exports = __webpack_public_path__ + "img/battery_elec_icon.af0237cf.png";